import moneyFlowCommon from './common';
import moneyFlowContribution from './contribution';
import moneyFlowProprietary from './proprietary';
import moneyFlowForeign from './foreign';
import moneyFlowStatisticInvestor from './statisticInvestor';

export default {
  moneyFlowCommon,
  moneyFlowContribution,
  moneyFlowProprietary,
  moneyFlowForeign,
  moneyFlowStatisticInvestor,
};
